"use client";

import type { ReactNode } from "react";
import { AnalyticsProvider } from "@/lib/analytics";
import { LocaleProvider } from "@/lib/context/LocaleProvider";
import { ThemeProvider } from "@/lib/context/ThemeProvider";
import { AuthProvider } from "@/lib/context/AuthProvider";
import { PersonalizationProvider } from "@/lib/context/PersonalizationProvider";
import { ProjectsProvider } from "@/lib/context/ProjectsProvider";
import { UIProvider } from "@/lib/context/UIProvider";
import { UtmProvider } from "@/lib/context/UtmProvider";

/** All client-side context providers, composed in one place. */
export function Providers({ children }: { children: ReactNode }) {
  return (
    <UtmProvider>
      <LocaleProvider>
        <ThemeProvider>
          <AuthProvider>
            <AnalyticsProvider>
              <PersonalizationProvider>
                <ProjectsProvider>
                  <UIProvider>{children}</UIProvider>
                </ProjectsProvider>
              </PersonalizationProvider>
            </AnalyticsProvider>
          </AuthProvider>
        </ThemeProvider>
      </LocaleProvider>
    </UtmProvider>
  );
}
